import { render, staticRenderFns } from "./settlementOrderDetails.vue?vue&type=template&id=3cf899df&scoped=true"
import script from "./settlementOrderDetails.vue?vue&type=script&lang=js"
export * from "./settlementOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./settlementOrderDetails.vue?vue&type=style&index=0&id=3cf899df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf899df",
  null
  
)

export default component.exports